import React, { FunctionComponent } from 'react'; // importing FunctionComponent
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import "primeicons/primeicons.css";


type PendingTableProps = {
    customers:any, 
    first:any, 
    sortField:any, 
    sortOrder:any,
    totalRecords:any, 
    onPage:any, 
    onSort:any, 
    onFilter:any, 
    filters:any,
    loading:any, 
    countryBodyTemplate:any,
    representativeBodyTemplate:any,
    actionBodyTemplate:any  
  }
  var width = window.screen.width;
    var c_rows = 10;
    // if(width>=1920){
    //     c_rows=13
    // }
    // else if(width>=1400 || width<=1600){
    //     c_rows=10
    // }
    const rowsNo = ()=>{
      var width = window.screen.width;
      
      if(width>=1920){
        return 13
      }else if(width>1420 && width<=1440 ){
        return 9
      }
      else{
        return 10
      }
    }
  // we can use children even though we haven't defined them in our CardProps
export const PendingDietitianTable: FunctionComponent<PendingTableProps> = ({ customers, first, sortField,sortOrder, totalRecords, onPage, onSort, onFilter,filters, loading,countryBodyTemplate,representativeBodyTemplate,actionBodyTemplate}) => 
  <DataTable 
className='pending-table-heads'
  value={customers} 
  lazy
  filterDisplay="row" 
  responsiveLayout="scroll" 
  // dataKey={}
  paginator 
  first={first} 
  rows={rowsNo()} 
  totalRecords={totalRecords} 
  onPage={onPage}
  onSort={onSort} 
  sortField={sortField} 
  sortOrder={sortOrder}
  onFilter={onFilter} 
  filters={filters} 
  loading={loading}
  >
  <Column field="dietitianname" header="Dietitian Name" sortable filter filterPlaceholder="Search by Name" />
  <Column field="city" sortable header="City" filter filterPlaceholder="Search by city" />
  <Column field="speciality" header="Speciality" sortable filter filterPlaceholder="Search by Agent" />
  <Column body={actionBodyTemplate} header="Action" className='action_btn'   exportable={false} style={{ minWidth: '6rem' }}></Column>

</DataTable>